<template>
  <v-card class="p-4">
    <UploadFiles2 @addCsvUser="addUser"/>
    <!-- titre de la page + add user -->
    <v-card-title class="pt-10" style="width:100%">
      Nos utilisateurs
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Rechercher sur les noms"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>

      <export-btn entity="users"/>

      <v-btn v-if="selected.length >= 1" class="mx-2" fab dark small color="orange darken-2" data-toggle="tooltip" title="Réinitialisation du mot de passe">
        <v-icon dark v-model="selected" small @click.stop="resetPasswordUsers()">
          mdi-lock-reset
        </v-icon>
      </v-btn>
      <!-- bouton trash à partir de 2 checkbox de cocher -->
      <v-btn v-if="selected.length >= 2" class="mx-2" fab dark small color="red" data-toggle="tooltip" title="Suppression des utilisateurs sélectionnées" >
        <v-icon dark v-model="selected" small @click="deleteUsers(selected[0].user)">
          mdi-delete
        </v-icon>
      </v-btn>
      <v-btn v-if="selected.length >= 2" class="mx-2" fab dark small color="purple darken-2" data-toggle="tooltip" title="Edition des utilisateurs sélectionnées">
        <v-icon dark v-model="selected" small @click.stop="editMultiple()">
          mdi-pencil
        </v-icon>
      </v-btn>
      <router-link :to="{ name: 'creerUtilisateur' }">
        <v-btn class="mx-2" fab dark small color="indigo"  data-toggle="tooltip" title="Création d'un utilisateur">
          <v-icon dark>
            mdi-plus
          </v-icon>
        </v-btn>
      </router-link>
    </v-card-title>
    <!-- tableau + selection multiple + corbeille -->
    <v-skeleton-loader
        v-if="loading"
        type="table"
        :types="{ 'table': 'table-thead, table-tbody, table-tfoot', 'table-tbody': 'table-row-divider@12' }"
        min-width="100%"
    />
    <v-data-table
      :hidden="loading"
      :headers="headers"
      :items="users"
      :server-items-length="totalItems"
      :search-input.sync="search"
      :options.sync="options"
      :items-per-page="12"
      :page.sync="pagination.currentPage"
      hide-default-footer
      v-model="selected"
      :single-select="singleSelect"
      show-select
    >
      <!-- date de création de l'utilisateur -->
      <template v-slot:item.createdAt="{ item }">
        <span v-if="item.createdAt">{{ item.createdAt|moment}}</span>
      </template>
      <template v-slot:item.lastConnection="{ item }">
        <span v-if="item.lastConnection">{{ item.lastConnection|moment }}</span>
        <span v-else>Aucune connexion</span>
      </template>
      <!-- modification / supression utilisateur -->
      <template v-slot:[`item.actions`]="{ item }">
        <router-link :to="{ name: 'modifierUtilisateur', params: { id: item.id, user: item },}">
          <v-icon small class="mr-2">mdi-pencil</v-icon>
        </router-link>
        <v-icon small @click="deleteUser(item)">mdi-delete</v-icon>
      </template>
      <!-- Envoi initialisation de mdp -->
      <template v-slot:item.hasPassword="{ item }">
        <v-icon v-if="item.hasPassword" small color="green">mdi-checkbox-marked-circle</v-icon>
        <v-icon v-else small color="red">mdi-checkbox-blank-circle</v-icon>
      </template>
      <!-- Définition du type-->
      <template v-slot:item.type="{ item }">
            <v-chip x-small class="pa-2" color="pink" text-color="white" v-if="item.type == '0'" >Interne</v-chip>
            <v-chip x-small class="pa-2" color="blue" text-color="white" v-if="item.type == '1'" >SSO</v-chip>
      </template>
    </v-data-table>
    <UserRightModal
      :userRights="userRights"
      :dialog="this.dialog"
      @onClose="dialog=false"
      @selectUserRight="editUserRight"
    ></UserRightModal>
    <v-pagination
      v-model="pagination.currentPage"
      :length="pagination.pagesNumber"
      class="pt-5"
    ></v-pagination>
  </v-card>
</template>
<script>
//import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";
import moment from "moment";
import UserRightModal from "@/components/admin/userRight/modal/userRightModal";
import UploadFiles2 from "@/components/files/uploadFiles2";
import ExportBtn from "@/components/admin/exportBtn";


export default {
  name: "users",
  components: { UserRightModal, UploadFiles2, ExportBtn },
  data() {
    return {
      confirmDelete: false,
      loading: true,
      options: {},
      search: "",
      headers: [
        { text: "Type", value: "type" , align:"center"},
        { text: "Nom", value: "lastname", align: "start" },
        { text: "Prénom", value: "firstname", align: "start" },
        { text: "E-mail", value: "email", align: "start" },
        { text: "Rôle", value: "roles[0]", align: "start" },
        { text: "Client", value: "client.name", align: "start" },
        { text: "Droit utilisateur", value: "userRight.name", align: "start" },
        { text: "Dernière connexion", value: "lastConnection", align: "start" },
        { text: "Nb connexions", value: "nbConnection", align: "start" },
        {
          text: "Parcour(s) démarré(s)",
          value: "nbCourseStarted",
          align: "start",
        },
        {
          text: "Parcour(s) complété(s)",
          value: "nbCourseCompleted",
          align: "start",
        },
        { text: "Crée le", value: "createdAt", align: "start" },
        { text: "Mot de passe", value: "hasPassword", align: "center" },
        { text: "Actions", value: "actions", sortable: false, align: "center" },
      ],
      users: [],
      pagination: {
        currentPage: 1,
        pagesNumber: 0,
      },
      totalItems: 0,
      deletedIndex: -1,
      singleSelect: false,
      selected: [], // Liste des utilisateurs sélectionnés dans le tableau
      dialog: false,
      userRights: [],
    };
  },
  filters: {
    moment: function(date) {
      return moment.parseZone(date).format("DD/MM/YYYY");
    },
  },
  watch: {
    search(value) {
      this.search = value;
      this.pagination.currentPage = 1;
      this.getAllUsers();
    },
    options: {
      handler() {
        this.getAllUsers();
      },
      deep: true
    }
  },
  methods: {
    downloadCSV(rows,csvName) {
      let csvContent = "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n");
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", csvName);
      document.body.appendChild(link);
      link.click();
    },
    getAllUsers() {
      this.loading = true;
      let params = { search_global: this.search, roles: {
        not_like: "ROLE_ADMIN" // All but admins
      }};
      if (this.options.sortBy) {
        for (let i = 0; i < this.options.sortBy.length; i++) {
          // Replace roles[0] with roles for backend sorting
          const sortBy = this.options.sortBy[i] === 'roles[0]' ? 'roles' : this.options.sortBy[i];
          const sortDesc = this.options.sortDesc[i] ? 'desc' : 'asc';
          params[`order[${sortBy}]`] = sortDesc;
        }
      }
      Api.query("users?page=" + this.pagination.currentPage, { params }).then(users => {
        this.users = users.data["hydra:member"];
        this.totalItems = users.data["hydra:totalItems"];
        this.pagination.pagesNumber = Math.ceil(this.totalItems / 12);
        this.loading = false;
        
      });
    },
    deleteUser(item) {
      Swal.fire({
        title: "Voulez-vous vraiment supprimer cet utilisateur ?",
        text: "Attention, cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer",
        cancelButtonText: "Annuler",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deletedIndex = this.users.indexOf(item);
          Api.delete("users/" + item.id).then(() => {
            this.users.splice(this.deletedIndex, 1),
              Swal.fire(
                "Supprimé !",
                "Votre utilisateur a été supprimé",
                "success"
              ),
              this.selected = [];
              this.getAllUsers();
          });
        }
      });
    },
    deleteUsers() {
      Swal.fire({
        title: "Voulez-vous vraiment supprimer ces utilisateurs ?",
        text: "Attention, cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer",
        cancelButtonText: "Annuler",
      }).then((result) => {
        if (result.isConfirmed) {
          const selectedItems = this.selected
          for(var i=0; i < selectedItems.length; i++){
            //let deletedIndex = this.users.findIndex(el => el.user === selectedItems[i]);
            Api.delete("users/" + selectedItems[i].id).then(() => { //TODO : appeler la fonction de callback. cf https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Global_Objects/Promise/all
            //this.users.splice(deletedIndex, 1);
              Swal.fire(
                "Supprimé !",
                "Votre utilisateur a été supprimé",
                "success"
              ),
              this.getAllUsers();
            });
          }
        }
      });
    },
    resetPasswordUsers() {
      let self = this;
      let rows = [["last_name","first_name","email","client","new_password"]];
      Swal.fire({
        title: "Voulez-vous vraiment réinitialiser et/ou initialiser les mots de passe des utilisateurs sélectionnés ?",
        text: "Attention, cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, réinitialiser",
        cancelButtonText: "Annuler",
      }).then((result) => {
        if (result.isConfirmed) {
          // Demande de réinitialisation et d'initialisation des mots de passe 
          const selectedItems = this.selected
          const promises = [];
          for(var i=0; i < selectedItems.length; i++){
            if(!selectedItems[i].hasPassword){
              // envoie initialisation mot de passe
              Api.patch('users', `${selectedItems[i].id}/send-password`, {id: selectedItems[i].id});
            }else{
              // envoie réinitialisation mot de passe
              promises.push(Api.patch('users', `${selectedItems[i].id}/reset-password`, {id: selectedItems[i].id}));
            }
            
          }
          // Attente de la complètion des demandes serveur
          Promise.all(promises).then(function(values){
            console.log(values);
            // Message de confirmation 
            Swal.fire({
              title: "",
              text: "La réinitialisation et l'initialisation des mots de passes a été réalisée avec succès.",
              icon: "success"
            });
            // Création du csv
            values.forEach(el => {
              if(el.data["hydra:member"]) {
                rows.push([
                  el.data["hydra:member"][0]['lastname'],
                  el.data["hydra:member"][0]['firstname'],
                  el.data["hydra:member"][0]['email'],
                  el.data["hydra:member"][0]['client']["name"],
                  el.data["hydra:member"][1]]
                )
              }
            });
            self.downloadCSV(rows,"reset-init-password.csv");
            self.getAllUsers();
          }).catch((err) => {
              Swal.fire({
              title: "",
              text: "Une erreur s'est produite durant la réinitialisation des mots de passe.",
              icon: "error"
            });
            console.log(err);
          });
        }
      });
    },

    editUserRight(userRight) {
      this.dialog = false;
      this.loading = true;
      for(const user of this.selected) {
        Api.patch('users', user.id, {
          userRight: userRight["@id"]
        })
        .then(() => {
          user.userRight = userRight;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loading = false));
      }
    },
    // method pour edit multiple
    editMultiple(){
      if(this.selected[0].client){
        this.userRights = this.selected[0].client.userRights
      }
      this.dialog = true;
    },
    addUser(newUser) {
      this.users.push(newUser);
      this.getAllUsers();
    }
  },
  mounted() {
    // this.$store.dispatch(SET_BREADCRUMB, [
    //   { title: "Administration", route: "gestionClients"},
    //   { title: "Gestion des utilisateurs" },
    // ]);
    this.getAllUsers();
  },
};
</script>
